exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_box_tWy-0 {\n}\n", ""]);

// exports
exports.locals = {
	"box": "box_box_tWy-0"
};